import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registered after load so it never competes with the first paint. The worker
// itself does nothing but pass requests through; it is here because a browser
// will only offer to install an application that registers one.
//
// Failure is ignored on purpose: an install prompt that does not appear is a
// missing convenience, not a fault worth showing anybody.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
